import $ from 'jquery'
import SimpleTooltip from "../../../../SimpleTooltip"
import messageResource from '../../../../messageResource'

export default class AllScopeTooltip extends SimpleTooltip {
    constructor() {
        super({extraClass: 'userlist_workAssignmentsTab_allScopeTooltip'})

        this.state = {
            name: ''
        }

        this.onStateChanged(() => this._updateText())
    }

    _updateText() {
        this.setText(messageResource.getMessage('userlist.work_assignments.table.tooltip.all_scope', [this.state.name]))
    }
}

let instance = null
export const getInstance = () => {
    if (instance === null) {
        instance = new AllScopeTooltip().init($('body'))
    }
    return instance
}



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/workAssignmentsTab/components/AllScopeTooltip.js